import React, { Fragment } from 'react'
import { imgUrlConverter, actionUrlConverter } from '../../util/util'

export const SalesReps = React.memo(({ appData:{customerdata}, appData:{storedata} }) => {
	
	const salesRepData = customerdata?.filter(data => data.contentType === "SchoolStoreReps")[0]
	const schoolStoreReps = storedata?.schoolStoreReps?.sort((a, b) => a.orderSeq > b.orderSeq ? 1 : -1)

	

	return (
		<div className="rep-contact" id="rep-contact">
            <div className="container">
				<div className="img-wrapper">
					<picture>
						<source media="(min-width: 1200px)" srcSet={salesRepData && imgUrlConverter(salesRepData.imageUrl.xl)} />
						<source media="(min-width: 1024px)" srcSet={salesRepData && imgUrlConverter(salesRepData.imageUrl.lg)} />
						<source media="(min-width: 768px)" srcSet={salesRepData && imgUrlConverter(salesRepData.imageUrl.md)} />
						<source media="(min-width: 576px)" srcSet={salesRepData && imgUrlConverter(salesRepData.imageUrl.sm)} />
						<img src={salesRepData && imgUrlConverter(salesRepData.imageUrl.xl)} alt={salesRepData && salesRepData.imageAltText} />
					</picture>
				</div>
			</div>
            <div className="overlay">
				<div className="inner">
					<h2>Contact your sales reps</h2>
					<ul className="contacts">
                    	{schoolStoreReps?.map((rep, key) => {
							let yb = 0
							const descr = rep.description?.split('<linkText>Customer Service.</linkText>')
							return (
								<li key={`Sales Rep ${key}`}>
									<h4 margin="0 10px 0 0">
									{
										rep.assignmentTypes.map((type, key) => {
											if (type.toLowerCase() === 'yearbooks') {
												yb = 1
											} 
											return <Fragment key={`AssignmentType-${key}`}>{`${(key > 0) ? ', ' : ''}${type.toUpperCase()}`}</Fragment>
										})
									}
									</h4>
									{rep.linkText && descr?.length > 1 ? <p>{descr[0]}<a href={actionUrlConverter(rep.linkText)}>Customer Service.</a>{descr[1]}</p> : <p>{rep.description}</p>}
									<h3>{rep.salesRepName}</h3>
									<ul>
										{rep.phoneNumber && <li><a href="#">{rep.phoneNumber}</a></li>}
										{rep.emailAddress && <li><a href={`mailto:${rep.emailAddress}`}>{rep.emailAddress}</a></li>}
										{/* {yb ? <li><a href={actionUrlConverter('https://www.jostens.com/yearbooklove')}>yearbooklove.com</a></li> : null} */}
									</ul>
								</li>
							)}
						)}
						{/* <li key={`Sales Rep 999`}>
							<h4 margin="0 10px 0 0">Jostens Customer Service</h4>
							<p>If you have questions about Jostens products you have purchased, you can also contact <a href={actionUrlConverter("https://www.jostens.com/contact")}>Customer Service.</a></p>
						</li> */}
					</ul>
				</div>
			</div>
		</div>
	)
})

// export default React.memo(SalesReps)